module.exports = __webpack_public_path__ + "img/mind_network.ed28d548.png";